import Stack from "@mui/material/Stack";

import RichTextEditor from "@/features/shared/components/rte/rte";
import { FormValues } from "@/types/widget";
import { BasicWidgetFormProps } from "@/features/widget-forms/dialogs/widget-dialog-types";

const getInitialValues = (values: FormValues) => {
  const configuration = values?.configuration ?? {};

  if ("content" in configuration) {
    return configuration.content as string;
  }

  return "";
};

export function RichTextWidgetForm({ values }: BasicWidgetFormProps) {
  const initialValues = getInitialValues(values);

  return (
    <Stack mt={2}>
      <RichTextEditor name="configuration.content" initialValue={initialValues} />
    </Stack>
  );
}
